const customOffset = 55;

function checkOverflow(element, scollableContainer) {
  const nextButton = scollableContainer?.querySelector('[data-pc-section="nextbutton"]');
  const prevButton = scollableContainer?.querySelector('[data-pc-section="prevbutton"]');
  const buttonSize = Math.max(prevButton?.offsetWidth || 0, nextButton?.offsetWidth || 0);
  const diffRight = Math.max(((element?.offsetLeft ?? 0) + (element?.offsetWidth ?? 0) + buttonSize + customOffset)
            - ((scollableContainer?.offsetWidth ?? 0) + (scollableContainer?.scrollLeft ?? 0)), 0);
  const diffLeft = Math.max(
    (scollableContainer?.scrollLeft ?? 0) + buttonSize + customOffset - (element?.offsetLeft ?? 0),
    0);

  return {
    isOverflow: diffRight > 0 || diffLeft > 0,
    diffLeft,
    diffRight,
  };
}

/**
 * Hides nav next button when reaching the maximum scrollable left amount. Missing behavior in primevue
 *
 */
function checkNextButtonVisibility(rootNode) {
  // Hides nav next button when reaching the maximum scrollable left amount
  const tablistContent = rootNode?.querySelector('[data-pc-section="content"]');
  if (!tablistContent) return;
  const { scrollLeft, scrollWidth, offsetWidth } = tablistContent;
  const nextButton = rootNode?.querySelector('[data-pc-section="nextbutton"]');
  if (!nextButton) return;
  if (scrollLeft + offsetWidth >= scrollWidth - 10) {
    nextButton.style.display = 'none';
  } else {
    nextButton.style.display = 'flex';
  }
}

/**
 *  When selected tab overflows the tabs container, scroll the container to focus on the selected tab by the offset to make the tab button fully visible in the viewport. Missing behavior in primevue
 * @returns {Object} Object {isOverflow, diffRight, diffLeft}
 * isOverflow: the selected tab is overflowing the viewport
 * diffRight: overflowing offset at the right side
 * diffLeft:  overflowing offset at the left side
 */
function moveToFocusSelectedTab(rootNode) {
  const tablistContent = rootNode?.querySelector('[data-pc-section="content"]');
  const tab = rootNode?.querySelector(`button[data-p-active="true"]`);
  const { isOverflow, diffLeft, diffRight } = checkOverflow(tab, tablistContent);
  if (isOverflow) {
    if (diffRight > 0) {
      tablistContent?.scrollBy({ left: diffRight });
    } else if (diffLeft > 0) {
      tablistContent?.scrollBy({ left: -diffLeft });
    }
  }
}

export { checkNextButtonVisibility, moveToFocusSelectedTab };
